angular.module('app.controllers').controller('AuthCtrl', ['$scope', '$rootScope', '$location', 'UI'].append(function(self, root, $location, UI) {
  var params;
  params = $location.search();
  if (params && angular.isDefined(params.password_restore)) {
    $location.path("/password-forgot");
  }
  if (params && angular.isDefined(params.auth_ticket)) {
    $location.path("/password-new");
  }
  if (params && angular.isDefined(params.confirm)) {
    $location.path("/confirm");
  }
  if (params && angular.isDefined(params.validated)) {
    $location.path("/verification");
  }
}));

angular.module('app.controllers').controller('RegistrationCtrl', ['$scope', '$rootScope', 'APIVisitor', '$timeout', '$location', 'APIConfirm', 'smoothScr', 'APICheckEmail', 'UI', '$cookies', 'APICheckin', 'APIEloqua'].append(function(self, root, APIVisitor, $timeout, $location, APIConfirm, smoothScr, APICheckEmail, UI, $cookies, APICheckin, APIEloqua) {
  //  1 - init screen 
  //  2 - confirmed/login
  //  3 - fill data
  //  4 - ticket scan
  self.forgotModalEl = document.getElementById('forgotModal');
  if (self.forgotModalEl) {
    self.forgotModal = bootstrap.Modal.getOrCreateInstance(self.forgotModalEl);
  }
  self.repeatModalEl = document.getElementById('repeatModal');
  if (self.repeatModalEl) {
    self.repeatModal = bootstrap.Modal.getOrCreateInstance(self.repeatModalEl);
  }
  self.step = 1;
  self.formProccess = false;
  self.formSuccess = false;
  self.passType = true;
  self.passType2 = true;
  self.togglePass = function(pass = true) {
    if (pass) {
      return self.passType = !self.passType;
    }
    return self.passType2 = !self.passType2;
  };
  self.setStep = function(step) {
    return self.step = step;
  };
  APIEloqua.query({
    lang: 'en'
  }, function(data) {
    self.initData = angular.copy(data);
    return self.resetData(self.initData);
  }, function(response) {
    return UI.notify(false, response.data.error);
  });
  self.resetData = function(eloqua = [], reset = false) {
    var field, i, ind, l, len, models, q, ref;
    self.data = {
      gender: "",
      first_name: "",
      last_name: "",
      phone: "",
      address: "",
      zip: "",
      city: "",
      country: "",
      company: "",
      position: "",
      email: "",
      password: "",
      source: "",
      ticket_category: "",
      locale: "EN",
      shortcode_supplementary: "",
      settings: {
        additional_field: {
          additional_field_label_1: "Yes, I would like to receive marketing information from Siemens based on my personal interests and give the consent described in detail here",
          additional_field_value_1: false
        }
      }
    };
    self.fake = {
      email: "",
      password: ""
    };
    models = {
      salutation: 'gender',
      firstName: 'first_name',
      lastName: 'last_name',
      postCode: 'zip'
    };
    for (ind = i = 0, len = eloqua.length; i < len; ind = ++i) {
      q = eloqua[ind];
      field = ((ref = q.dvm) != null ? ref.name : void 0) || q.name;
      if (field === 'salutation') {
        eloqua[ind].values = q.values.map(function(it) {
          var gender;
          gender = "null";
          if (['mr.'].some(function(a) {
            return it.value.toLowerCase().includes(a);
          })) {
            gender = "true";
          }
          if (['ms.'].some(function(a) {
            return it.value.toLowerCase().includes(a);
          })) {
            gender = "false";
          }
          it.value = gender;
          return it;
        });
      }
      if (field !== 'salutation' && field !== 'firstName' && field !== 'lastName' && field !== 'email' && field !== 'country' && field !== 'postCode') {
        l = (Object.keys(self.data.settings.additional_field).length / 2) + 1;
        self.data.settings.additional_field[`additional_field_label_${l}`] = `${q.title}`;
        self.data.settings.additional_field[`additional_field_value_${l}`] = "";
        eloqua[ind].model = `additional_field_value_${l}`;
        eloqua[ind].additional = true;
      } else {
        eloqua[ind].model = models[field] || field;
        eloqua[ind].additional = false;
      }
      if (q.type === 'choice') {
        eloqua[ind].values.unshift({
          value: "",
          name: "- Please select -"
        });
      }
    }
    return $timeout(function() {
      return self.eloqua = angular.copy(eloqua);
    }, 100);
  };
  self.saveForm = function(form) {
    return self.rForm = form;
  };
  self.register = function() {
    self.formProccess = true;
    return (new APIVisitor(self.data)).$save({
      xlocale: root.lang || 'de'
    }, function(data) {
      var ref, ref1;
      self.done_email = angular.copy(self.data.email);
      self.formProccess = false;
      self.formSuccess = true;
      self.resetData(self.initData);
      if ((ref = self.rForm) != null) {
        ref.$setPristine();
      }
      if ((ref1 = self.rForm) != null) {
        ref1.$setUntouched();
      }
      $timeout(function() {
        return smoothScr.scroll('#body-top', 0);
      });
      return self.forgotModal.show();
    }, function(response) {
      self.formProccess = false;
      self.formSuccess = false;
      return UI.notify(false, response.data.error);
    });
  };
  self.checkData = function() {
    return console.log(self.data);
  };
  self.checkEmail = function() {
    self.formProccess = true;
    return APICheckEmail.get({
      email: self.data.email,
      xlocale: root.lang || 'de'
    }, function() {
      self.formProccess = false;
      return self.register();
    }, function(response) {
      self.formProccess = false;
      if (response.data.error === "Ein Ticket mit dieser E-Mail-Adresse wurde bereits registriert") {
        return self.repeatModal.show();
      } else {
        self.data.email = '';
        return UI.notify(false, response.data.error);
      }
    });
  };
  return self.sendLink = function() {
    if (!self.data.email) {
      return;
    }
    self.formProccess = true;
    self.formError = false;
    return (new APICheckin()).$save({
      action: 'password_lost',
      email: self.data.email,
      xlocale: root.lang || 'de'
    }, function(data) {
      var ref, ref1;
      self.formProccess = false;
      self.formSuccess = true;
      self.resetData(self.initData);
      if ((ref = self.rForm) != null) {
        ref.$setPristine();
      }
      if ((ref1 = self.rForm) != null) {
        ref1.$setUntouched();
      }
      return self.repeatModal.hide();
    }, function(response) {
      self.data.email = '';
      self.formSuccess = false;
      self.formProccess = false;
      if (response.data.error !== "E-Mail not confirmed") {
        self.formError = true;
      }
      return UI.notify(false, response.data.error);
    });
  };
}));

angular.module('app.controllers').controller('ConfirmCtrl', ['$scope', '$timeout', '$location', 'APIConfirm', '$rootScope', 'UI', '$cookies', 'APIActivity'].append(function(self, $timeout, $location, APIConfirm, root, UI, $cookies, APIActivity) {
  var params;
  self.formProccess = false;
  self.formSuccess = false;
  params = $location.search();
  self.autologin = function(data) {
    var usercookie;
    self.formProccess = false;
    self.formSuccess = true;
    usercookie = {
      shortcode: data.shortcode,
      auth_ticket: data.auth_ticket,
      role: data.role || null,
      guest: false
    };
    $cookies.putObject('user', usercookie);
    $location.search('confirm', null);
    $location.search('lang', null);
    return root.$emit('proveSession', true);
  };
  if (params && angular.isDefined(params.confirm)) {
    self.formProccess = true;
    return APIConfirm.get({
      hash: params.confirm,
      xlocale: root.lang || 'de'
    }, function(data) {
      return self.autologin(data);
    }, function(response) {
      self.formProccess = false;
      self.formSuccess = false;
      UI.notify(false, response.data.error);
      $location.search('confirm', null);
      $location.search('lang', null);
      return $location.path("/");
    });
  } else {
    return $location.path("/");
  }
}));

angular.module('app.controllers').controller('PasswordCtrl', ['$scope', '$rootScope', 'APICheckin', '$timeout', '$location', 'UI', 'APIFavorites', '$translate', '$cookies'].append(function(self, root, APICheckin, $timeout, $location, UI, APIFavorites, $translate, $cookies) {
  var params;
  self.step = 1;
  self.formSuccess = false;
  self.passType = true;
  self.passType2 = true;
  self.togglePass = function(pass = true) {
    if (pass) {
      return self.passType = !self.passType;
    }
    return self.passType2 = !self.passType2;
  };
  params = $location.search();
  (self.resetData = function() {
    self.data = {
      email: '',
      hash: '',
      password: ''
    };
    self.fake = {
      password: ''
    };
    self.formError = false;
    return self.formProccess = false;
  })();
  self.saveForm = function(form) {
    return self.fForm = form;
  };
  self.autologin = function(data) {
    var usercookie;
    self.formProccess = false;
    self.formSuccess = true;
    usercookie = {
      shortcode: data.shortcode,
      auth_ticket: data.auth_ticket,
      role: data.role || null,
      guest: false
    };
    $cookies.putObject('user', usercookie);
    $location.search('confirm', null);
    $location.search('lang', null);
    return root.$emit('proveSession', true, false, true);
  };
  self.acceptLogin = function() {
    if (!self.data.email) {
      return;
    }
    self.formProccess = true;
    return APIFavorites.get({
      shortcode: self.data.email,
      entrycode: 'reg'
    }, function(data) {
      self.formProccess = false;
      if ((data != null ? data.shortcode : void 0) === self.data.email) {
        return self.autologin(data.entrydata);
      } else {
        return $translate('pages.welcome.labels.email').then(function(trs) {
          return UI.notify(false, trs);
        });
      }
    }, function(response) {
      self.formProccess = true;
      return UI.notify(false, response.data.error);
    });
  };
  
  // Request new password

  self.forgotModalEl = document.getElementById('forgotModal');
  if (self.forgotModalEl) {
    self.forgotModal = bootstrap.Modal.getOrCreateInstance(self.forgotModalEl);
  }
  self.forgotPass = function() {
    if (!self.data.email) {
      return;
    }
    self.formProccess = true;
    self.formError = false;
    return (new APICheckin()).$save({
      action: 'password_lost',
      email: self.data.email,
      xlocale: root.lang || 'de'
    }, function(data) {
      self.resetData();
      self.formSuccess = true;
      self.resetData();
      if (self.fForm != null) {
        self.fForm.$setPristine();
        self.fForm.$setUntouched();
      }
      return self.forgotModal.show();
    }, function(response) {
      self.data.email = '';
      self.formSuccess = false;
      self.formProccess = false;
      if (response.data.error !== "E-Mail not confirmed") {
        self.formError = true;
      }
      return UI.notify(false, response.data.error);
    });
  };
  
  // Save new password

  if (params && angular.isDefined(params.password_restore)) {
    self.step = 2;
    self.data.hash = params.password_restore;
    self.data.email = params.email;
  }
  self.savePass = function() {
    if (!self.data.email) {
      return;
    }
    if (!self.data.password) {
      return;
    }
    if (!self.data.hash) {
      return;
    }
    self.formProccess = true;
    return (new APICheckin(self.data)).$save({
      action: 'password_restore',
      xlocale: root.lang || 'de'
    }, function(data) {
      self.resetData();
      self.formSuccess = true;
      return self.formProccess = false;
    }, function(response) {
      self.formSuccess = false;
      self.formProccess = false;
      return UI.notify(false, response.data.error);
    });
  };
  
  // Set new password

  if (params && angular.isDefined(params.auth_ticket)) {
    self.step = 3;
    self.auth_ticket = params.auth_ticket;
  }
  self.setPass = function() {
    if (self.auth_ticket == null) {
      return;
    }
    self.formProccess = true;
    return (new APICheckin({
      password: self.data.password
    })).$save({
      _private: true,
      auth_ticket: self.auth_ticket,
      xlocale: root.lang || 'de'
    }, function(data) {
      self.resetData();
      self.formSuccess = true;
      return self.formProccess = false;
    }, function(response) {
      self.formSuccess = false;
      self.formProccess = false;
      return UI.notify(false, response.data.error);
    });
  };
  return self.forgotAction = function() {
    if (self.step === 1) {
      self.forgotPass();
    }
    if (self.step === 2) {
      self.savePass();
    }
    if (self.step === 3) {
      self.setPass();
    }
  };
}));
